





































































































import { Component, Vue } from "vue-property-decorator";
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import Buttons from "@/components/Buttons.vue";
import Promotion from "@/components/Promotion.vue";

@Component({
  components: {
    Buttons,
    Navbar,
    Footer,
  },
})
export default class Garantias extends Vue {
    selectedCar : string = '';

    costosDeServicio={
        'BALENOGLS': [
            ["5,000","3","$1,705.00"],
            ["10,000","6","$2,427.00"],
            ["20,000","12","$3,177.00"],
            ["30,000","18","$4,641.00"],
            ["40,000","24","$3,606.00"],
            ["50,000","30","$2,427.00"],
            ["60,000","36","$4,327.00"],
            ["70,000","42","$2,427.00"],
            ["80,000","48","$5,225.00"],
            ["90,000","54","$3,578.00"],
            ["100,000","60","$4,240.00"],
        ],
        'BALENOGLX':[
            ["5,000","3","$1,705.00"],
            ["10,000","6","$2,427.00"],
            ["20,000","12","$3,177.00"],
            ["30,000","18","$4,641.00"],
            ["40,000","24","$3,606.00"],
            ["50,000","30","$2,427.00"],
            ["60,000","36","$4,327.00"],
            ["70,000","42","$2,427.00"],
            ["80,000","48","$5,225.00"],
            ["90,000","54","$3,578.00"],
            ["100,000","60","$4,240.00"],
            
        ],
        'CIAZGLX2021': [  
              ["5,000","3","$1,705.00"],
            ["10,000","6","$2,427.00"],
            ["20,000","12","$3,177.00"],
            ["30,000","18","$3,578.00"],
            ["40,000","24","$3,606.00"],
            ["50,000","30","$2,427.00"],
            ["60,000","36","$4,327.00"],
            ["70,000","42","$2,427.00"],
            ["80,000","48","$5,225.00"],
            ["90,000","54","$3,578.00"],
            ["100,000","60","$4,240.00"],
            
        ],
        "ERTIGAGLS": [ 
            ["5,000","3","$1,705.00"],
            ["10,000","6","$2,427.00"],
            ["20,000","12","$3,177.00"],
            ["30,000","18","$4,641.00"],
            ["40,000","24","$3,606.00"],
            ["50,000","30","$2,427.00"],
            ["60,000","36","$4,327.00"],
            ["70,000","42","$2,427.00"],
            ["80,000","48","$5,485.00"],
            ["90,000","54","$3,578.00"],
            ["100,000","60","$4,240.00"],
           
        ],      

        "ERTIGAGLX": [
            ["5,000","3","$1,705.00"],
            ["10,000","6","$2,427.00"],
            ["20,000","12","$3,177.00"],
            ["30,000","18","$4,641.00"],
            ["40,000","24","$3,606.00"],
            ["50,000","30","$2,427.00"],
            ["60,000","36","$4,327.00"],
            ["70,000","42","$2,427.00"],
            ["80,000","48","$5,485.00"],
            ["90,000","54","$3,578.00"],
            ["100,000","60","$4,240.00"],
            
        ],
        "ERTIGAXL7": [
            ["5,000","3","$1,705.00"],
            ["10,000","6","$2,427.00"],
            ["20,000","12","$3,177.00"],
            ["30,000","18","$4,641.00"],
            ["40,000","24","$3,606.00"],
            ["50,000","30","$2,427.00"],
            ["60,000","36","$4,327.00"],
            ["70,000","42","$2,427.00"],
            ["80,000","48","$5,225.00"],
            ["90,000","54","$3,578.00"],
            ["100,000","60","$4,240.00"],
          
        ],
        "IGNISGLS": [
            ["5,000","3","$1,705.00"],
            ["10,000","6","$2,427.00"],
            ["20,000","12","$3,177.00"],
            ["30,000","18","$3,578.00"],
            ["40,000","24","$3,606.00"],
            ["50,000","30","$2,427.00"],
            ["60,000","36","$4,327.00"],
            ["70,000","42","$2,427.00"],
            ["80,000","48","$5,225.00"],
            ["90,000","54","$3,578.00"],
            ["100,000","60","$4,240.00"],
            
        ],
        "IGNISGLX": [
            ["5,000","3","$1,705.00"],
            ["10,000","6","$2,427.00"],
            ["20,000","12","$3,177.00"],
            ["30,000","18","$3,578.00"],
            ["40,000","24","$3,606.00"],
            ["50,000","30","$2,427.00"],
            ["60,000","36","$4,327.00"],
            ["70,000","42","$2,427.00"],
            ["80,000","48","$5,225.00"],
            ["90,000","54","$3,578.00"],
            ["100,000","60","$4,240.00"],
           
        ],
        "JIMNYGLX" : [
            ["5,000","3","$1,705.00"],
            ["10,000","6","$2,427.00"],
            ["20,000","12","$3,517.00"],
            ["30,000","18","$3,578.00"],
            ["40,000","24","$3,946.00"],
            ["50,000","30","$2,427.00"],
            ["60,000","36","$4,667.00"],
            ["70,000","42","$2,427.00"],
            ["80,000","48","$5,565.00"],
            ["90,000","54","$3,578.00"],
            ["100,000","60","$4,580.00"],
        ],
        "SCROSSBOOSTERJET": [
            ["5,000","3","$2,027.00"],
            ["10,000","6","$2,749.00"],
            ["20,000","12","$3,738.00"],
            ["30,000","18","$3,774.00"],
            ["40,000","24","$3,738.00"],
            ["50,000","30","$2,749.00"],
            ["60,000","36","$7,033.00"],
            ["70,000","42","$2,749.00"],
            ["80,000","48","$5,403.00"],
            ["90,000","54","$3,774.00"],
            ["100,000","60","$4,801.00"],
        ],
        "SCROSSGLX": [
            ["5,000","3","$1,705.00"],
            ["10,000","6","$2,427.00"],
            ["20,000","12","$3,117.00"],
            ["30,000","18","$3,578.00"],
            ["40,000","24","$3,606.00"],
            ["50,000","30","$2,427.00"],
            ["60,000","36","$4,327.00"],
            ["70,000","42","$2,427.00"],
            ["80,000","48","$5,225.00"],
            ["90,000","54","$3,578.00"],
            ["100,000","60","$4,220.00"],
        ],
        "SWIFTBOOSTERJET": [
            ["5,000","3","$2,027.00"],
            ["10,000","6","$2,749.00"],
            ["20,000","12","$3,738.00"],
            ["30,000","18","$3,774.00"],
            ["40,000","24","$3,738.00"],
            ["50,000","30","$2,749.00"],
            ["60,000","36","$6,552.00"],
            ["70,000","42","$2,749.00"],
            ["80,000","48","$5,357.00"],
            ["90,000","54","$3,774.00"],
            ["100,000","60","$4,801.00"],
        ],
        "SWIFTGLS": [
            ["5,000","3","$1,705.00"],
            ["10,000","6","$2,427.00"],
            ["20,000","12","$3,117.00"],
            ["30,000","18","$3,578.00"],
            ["40,000","24","$3,606.00"],
            ["50,000","30","$2,427.00"],
            ["60,000","36","$4,327.00"],
            ["70,000","42","$2,427.00"],
            ["80,000","48","$5,225.00"],
            ["90,000","54","$3,578.00"],
            ["100,000","60","$4,240.00"],
        ],
        "SWIFTGLX": [
            ["5,000","3","$1,705.00"],
            ["10,000","6","$2,427.00"],
            ["20,000","12","$3,117.00"],
            ["30,000","18","$3,578.00"],
            ["40,000","24","$3,606.00"],
            ["50,000","30","$2,427.00"],
            ["60,000","36","$4,327.00"],
            ["70,000","42","$2,427.00"],
            ["80,000","48","$5,225.00"],
            ["90,000","54","$3,578.00"],
            ["100,000","60","$4,240.00"],
        ],
        "SWIFTBOOSTERGREENGLS": [
            ["5,000","3","$1,705.00"],
            ["10,000","6","$2,427.00"],
            ["20,000","12","$3,177.00"],
            ["30,000","18","$2,570.00"],
            ["40,000","24","$3,606.00"],
            ["50,000","30","$2,427.00"],
            ["60,000","36","$5,590.00"],
            ["70,000","42","$2,427.00"],
            ["80,000","48","$5,225.00"],
            ["90,000","54","$5,225.00"],
            ["100,000","60","$4,240.00"],
           
        ],
        "SWIFTBOOSTERGREENGLX": [
            ["5,000","3","$1,705.00"],
            ["10,000","6","$2,427.00"],
            ["20,000","12","$3,177.00"],
            ["30,000","18","$2,570.00"],
            ["40,000","24","$3,606.00"],
            ["50,000","30","$2,427.00"],
            ["60,000","36","$5,590.00"],
            ["70,000","42","$2,427.00"],
            ["80,000","48","$5,225.00"],
            ["90,000","54","$5,225.00"],
            ["100,000","60","$4,240.00"],
           
        ],
        "SWIFTSPORTBOOSTERJET": [
            ["5,000","3","$2,027.00"],
            ["10,000","6","$2,749.00"],
            ["20,000","12","$4,341.00"],
            ["30,000","18","$3,774.00"],
            ["40,000","24","$4,341.00"],
            ["50,000","30","$2,749.00"],
            ["60,000","36","$7,296.00"],
            ["70,000","42","$2,749.00"],
            ["80,000","48","$5,960.00"],
            ["90,000","54","$3,774.00"],
            ["100,000","60","$5,404.00"],
           
        ],
        "VITARABOOSTERJET": [
            ["5,000","3","$2,027.00"],
            ["10,000","6","$2,749.00"],
            ["20,000","12","$3,738.00"],
            ["30,000","18","$3,774.00"],
            ["40,000","24","$3,738.00"],
            ["50,000","30","$2,749.00"],
            ["60,000","36","$7,033.00"],
            ["70,000","42","$2,749.00"],
            ["80,000","48","$5,403.00"],
            ["90,000","54","$3,774.00"],
            ["100,000","60","$4,801.00"],
           
        ],
        "VITARAGLX": [
           ["5,000","3","$1,705.00"],
            ["10,000","6","$2,427.00"],
            ["20,000","12","$3,177.00"],
            ["30,000","18","$3,578.00"],
            ["40,000","24","$3,606.00"],
            ["50,000","30","$2,427.00"],
            ["60,000","36","$4,327.00"],
            ["70,000","42","$2,427.00"],
            ["80,000","48","$5,225.00"],
            ["90,000","54","$3,578.00"],
            ["100,000","60","$4,240.00"],
           
        ],
        
    };

    imagenesCarros = {
    "BALENOGLS": ['https://cdn.marciano.space/suzuki/web-site-api/assets/cars/2023/baleno.png'] ,
    "BALENOGLX": ['https://cdn.marciano.space/suzuki/web-site-api/assets/cars/2023/baleno.png'] ,
    "CIAZGLX2021": ['https://cdn.marciano.space/suzuki/web-site-api/assets/cars/2021/CIAZ.png?v=1'],
    "ERTIGAGLS": ['https://cdn.marciano.space/suzuki/web-site-api/assets/cars/2023/ertiga-boostergreen.png'],
    "ERTIGAGLX":['https://cdn.marciano.space/suzuki/web-site-api/assets/cars/2023/ertiga-boostergreen.png'] ,
    "ERTIGAXL7":['https://cdn.marciano.space/suzuki/web-site-api/assets/cars/2023/ertiga-xl7.png?v=1'] ,
    "IGNISGLS": ['https://cdn.marciano.space/suzuki/cars/2021/IGNIS.png'],
    "IGNISGLX": ['https://cdn.marciano.space/suzuki/cars/2021/IGNIS.png'],
    "JIMNYGLX":[''] ,
    "SCROSSBOOSTERJET": ['https://cdn.marciano.space/suzuki/web-site-api/assets/cars/2023/s-cross.png?v=2'],
    "SCROSSGLX":['https://cdn.marciano.space/suzuki/cars/scross.png'] ,
    "SWIFTBOOSTERJET":['https://cdn.marciano.space/suzuki/cars/2021/SWIFT-2021.png'] ,
    "SWIFTGLS":['https://cdn.marciano.space/suzuki/cars/2021/SWIFT-2021.png'] ,
    "SWIFTGLX":['https://cdn.marciano.space/suzuki/cars/2021/SWIFT-2021.png'] ,
    "SWIFTBOOSTERGREENGLS":['https://cdn.marciano.space/suzuki/web-site-api/assets/cars/2022/swift-booster-green.png'] ,
    "SWIFTBOOSTERGREENGLX": ['https://cdn.marciano.space/suzuki/web-site-api/assets/cars/2022/swift-booster-green.png'],
    "SWIFTSPORTBOOSTERJET": ['https://cdn.marciano.space/suzuki/cars/swift-sport.png'] ,
    "VITARABOOSTERJET": ['https://cdn.marciano.space/suzuki/cars/vitara.png'] ,
    "VITARAGLX": ['https://cdn.marciano.space/suzuki/cars/vitara.png'] ,
    };
}
